import { render } from "./GiftPayment.vue?vue&type=template&id=a5f89ca2"
import script from "./GiftPayment.vue?vue&type=script&lang=js"
export * from "./GiftPayment.vue?vue&type=script&lang=js"

import "./GiftPayment.vue?vue&type=style&index=0&id=a5f89ca2&lang=scss"
script.render = render

export default script